import React from 'react';
import { invoiceBatchSingleUseOriginalFiles } from '../../lib/redux/actions/invoiceBatch';
import { connect } from 'react-redux';
import * as PropTypes from 'prop-types';
import { isSeniorStaff } from '../../lib/helper/authorisation';
import INVOICE_BATCH_STATUS from '../../lib/helper/statusCodes';
import { isMultiType } from '../../lib/helper/invoiceBatch';
import { addToast } from '../../lib/redux/actions/toast';
import { Modal, Button, Form } from 'react-bootstrap';

const mapStateToProps = (state) => ({
  ...state.auth,
});

const mapDispatchToProps = {
  invoiceBatchSingleUseOriginalFiles,
  addToast,
};

class UseOriginalFilesButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      selectedType: '',
    };
  }

  handleClick() {
    if (isMultiType(this.props.invoiceBatch.consultant)) {
      this.setState({ showModal: true, selectedType: '' });
    } else {
      this.useOriginalFiles();
    }
  }

  useOriginalFiles(data = {}) {
    const { invoiceBatchSingleUseOriginalFiles, invoiceBatch, addToast } = this.props;
    return invoiceBatchSingleUseOriginalFiles(invoiceBatch.id, data).then(() => {
      addToast('The invoice batch was set to use the original files', true);
    });
  }

  handleModalConfirm() {
    const { selectedType } = this.state;
    if (!selectedType) return;
    this.setState({ showModal: false });
    this.useOriginalFiles({ consultantTypeForFeeSchedule: selectedType });
  }

  render() {
    const { invoiceBatch } = this.props;
    const { showModal, selectedType } = this.state;

    if (!isSeniorStaff() || Number(invoiceBatch.status.code) !== Number(INVOICE_BATCH_STATUS.SUBMITTED)) {
      return null;
    }

    const consultantTypes = invoiceBatch.consultant?.consultantTypes ?? [];

    return (
      <>
        <button type="button" onClick={this.handleClick.bind(this)} className="btn btn-info">
          <i className="fa fa-arrow-circle-o-right mr-2" />
          Use Original Files
        </button>

        <Modal show={showModal} onHide={() => this.setState({ showModal: false })}>
          <Modal.Header closeButton>
            <Modal.Title>Select Fee Schedule Type</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>This consultant has multiple types. Please select which Fee Schedule to display for this batch.</p>
            <Form.Group>
              <Form.Label>Fee Schedule Type to Display</Form.Label>
              <Form.Control
                as="select"
                value={selectedType}
                onChange={(e) => this.setState({ selectedType: e.target.value })}>
                <option value="">Please select</option>
                {consultantTypes.map((ct) => (
                  <option key={ct['@id']} value={ct['@id']}>
                    {ct.displayName}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.setState({ showModal: false })}>
              Cancel
            </Button>
            <Button variant="primary" onClick={this.handleModalConfirm.bind(this)} disabled={!selectedType}>
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

UseOriginalFilesButton.propTypes = {
  invoiceBatch: PropTypes.object.isRequired,
  invoiceBatchSingleUseOriginalFiles: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(UseOriginalFilesButton);
